<template>
  <a
    v-if="isVisible"
    :href="url"
    class="p-the-a01-whats-new-notice-panel"
    :style="{ '--site-color': colorCode }"
    v-touch:tap
  >
    <div class="p-the-a01-whats-new-notice-panel__body">
      <span class="p-the-a01-whats-new-notice-panel__badge">NEW</span>
      <p class="p-the-a01-whats-new-notice-panel__text">
        新着のお知らせが{{ unreadCount }}件あります。
      </p>
    </div>
    <IconBase
      class="p-the-a01-whats-new-notice-panel__arrow"
      :width="24"
      :height="24"
      view-box="0 0 24 24"
      icon-color="#1f2021"
      icon-name="お知らせ一覧へ"
    >
      <IconArrowRight />
    </IconBase>
  </a>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import commons from "@/common/store/modules/commons";
import CONST_DATA from "@/general/mixins/const/constData";
import { getHeaderInfo } from "@/general/store/api";

@Options({
  name: "TheA01WhatsNewNoticePanel",
  components: {
    IconBase,
    IconArrowRight
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class TheA01WhatsNewNoticePanel extends Vue {
  unreadCount = 0;
  storeColorCode!: string;

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }

  get colorCode() {
    if (this.isGroupBudget) {
      return "#fc9014";
    }
    return this.storeColorCode;
  }

  get url() {
    return CONST_DATA.SITE_MAP.WHATS_NEW;
  }

  get isVisible() {
    return this.unreadCount > 0;
  }

  async created() {
    try {
      const headerInfo = await getHeaderInfo();
      this.unreadCount = headerInfo.whatnew_noread_cnt || 0;
    } catch {
      this.unreadCount = 0;
    }
  }
}
</script>

<style lang="scss" scoped>
.p-the-a01-whats-new-notice-panel {
  display: flex;
  gap: rem(16);
  align-items: center;
  width: 100%;
  margin-bottom: rem(16);
  padding: rem(8) rem(16);
  color: #1f2021;
  background-color: $common-white;
  border-radius: rem(8);
  box-shadow: 0 0 rem(4) rgba($common-black, 0.1);

  &__body {
    display: flex;
    flex: 1 0 0;
    gap: rem(8);
    align-items: center;
    min-width: 0;
  }

  &__badge {
    flex-shrink: 0;
    padding: rem(3) rem(10);
    color: $common-white;
    font-family: $font--noto-sans-only;
    font-size: rem(12);
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    background-color: var(--site-color);
    border-radius: rem(3);
    font-feature-settings: "palt" 1, "pwid" 1;
  }

  &__text {
    flex: 1 0 0;
    min-width: 0;
    color: #1f2021;
    font-family: $font--noto-sans-only;
    font-size: rem(16);
    font-weight: 700;
    line-height: 1.5;
    overflow-wrap: anywhere;
    font-feature-settings: "palt" 1, "pwid" 1;
  }

  &__arrow {
    flex-shrink: 0;
    width: rem(24);
    height: rem(24);
  }

  @include large-sp {
    padding: rem(12) rem(8);
  }

  @include sp {
    height: rem(45);

    &__text {
      font-size: rem(14);
    }
  }
}
</style>
